/* Native Shopify content is rendered by Liquid. JavaScript enhances filtering only. */
(() => {
  function mount(root) {
    if (root.dataset.enhanced) return;
    const cards = [...root.querySelectorAll('[data-project-card]')];
    if (!cards.length) return;
    root.dataset.enhanced = 'true';
    for (const card of cards) {
      const media = card.querySelector('.bn-project__media');
      const preview = media?.querySelector('template[data-project-preview]');
      if (!preview) continue;
      let requested = false;
      const loadPreview = () => {
        if (requested) return;
        requested = true;
        const fragment = preview.content.cloneNode(true);
        const image = fragment.querySelector('img');
        const ready = () => {if (image.naturalWidth) media.classList.add('has-scroll');};
        image.addEventListener('load', ready, {once:true});
        media.prepend(fragment);
        if (image.complete) ready();
      };
      media.addEventListener('pointerenter', event => {if (event.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) loadPreview();});
      media.addEventListener('focus', loadPreview);
    }
    const initial = Number(root.dataset.initial) || 9;
    const expand = root.querySelector('[data-project-expand]');
    const count = root.querySelector('[data-project-count]');
    const filters = root.querySelector('[data-project-filters]');
    let selected = 'Toate', expanded = false;
    function update() {
      const matches = cards.filter(card => selected === 'Toate' || card.dataset.category === selected);
      cards.forEach(card => { const index = matches.indexOf(card); card.hidden = index < 0 || (!expanded && index >= initial); });
      if (count) count.textContent = `${matches.length} proiecte${selected === 'Toate' ? '' : ' — ' + selected}`;
      if (filters) { filters.hidden = false; filters.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === selected))); }
      if (expand) { expand.hidden = matches.length <= initial; expand.setAttribute('aria-expanded', String(expanded)); expand.textContent = expanded ? 'Arată mai puține' : `Vezi încă ${matches.length - initial} proiecte`; }
    }
    let transition;
    let revision = 0;
    const grid = root.querySelector('[data-project-grid]');
    function refresh() {
      const current = ++revision;
      transition?.cancel();
      if (!grid || matchMedia('(prefers-reduced-motion: reduce)').matches) {update();return;}
      transition = grid.animate([{opacity:1},{opacity:0}],{duration:100,easing:'ease-out'});
      transition.finished.then(() => {
        if (current !== revision) return;
        update();
        transition = grid.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:180,easing:'ease-out'});
      }).catch(() => {});
    }
    root.addEventListener('click', event => {
      const filter = event.target.closest('[data-filter]');
      if (filter && root.contains(filter)) { selected = filter.dataset.filter; expanded = false; refresh(); }
      if (event.target.closest('[data-project-expand]')) { expanded = !expanded; refresh(); }
    });
    update();
  }
  const init = (scope = document) => scope.querySelectorAll('[data-bossnet-portfolio]').forEach(mount);
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
